import React, { useState } from 'react'
import { ReactComponent as Close } from "../assets/icons/x.svg";
import NewButton from './NewButton';
import { FileUploaderButton } from '../Components/FileUploaderButton';
import { FormTextInput } from '../Components/FormTextInput';
import { useScreenTransition } from '../Hooks/useScreenTransition';
import OrderChatBox from '../Components/OrderChatBox';


const RequestRevisionPopUp = ({ onCancel = () => { }, onClose = () => { }, userData, onSave = () => { }, files, pagesCount, handleFiles, handleDeleteFile, onChangePagesCount, windowSize, showDownloadButton }) => {

  const { transitionTo } = useScreenTransition();



  return (
    <div className='newPopUpModalWrap'>
      <div className="newPopUpModalContainer max-w-xl justify-start items-center relative">
        <h2 className="newPopUpModalTitle">Request Revision</h2>
        <Close className="newPopUpModalCloseIcon" onClick={onClose} />
        <div className='orderaddfilesPrimaryOptionsWrapper'>
          {/* <div className='generalChat'>
          <OrderChatBox
            userId={userData.id}
            userRole={userData.role}
            orderChatId={orderInfo.generalChatId}
                          orderData={orderInfo}
                          userData={userData}
          />
        </div> */}
          {/* <h2 className="orderaddfilesPrimaryTitle">Revision Files</h2> */}

          <div className='w-full'>
            <FileUploaderButton hideAddComment display text="Choose Files" files={files} showDownloadButton={showDownloadButton} handleFiles={handleFiles} handleDeleteFile={handleDeleteFile} fontSize={windowSize.width > 1024 ? 1.1 : windowSize.width > 767 ? (windowSize.orientation === 'portrait' ? 1.6 : 1.1) : (windowSize.orientation === 'portrait' ? 5 : 1.5)} />
          </div>
        </div>
        {
          !showDownloadButton && (<div className='w-full flex gap-4 '>
            <NewButton width='100%' text={"Cancel"} back={true} icon={false} whiteBtn={true} onClick={onCancel} />
            <NewButton
              width='100%'
              text={"Save"}
              disabled={files.length === 0 || files.some(el => el.status !== "complete")}
              onClick={onSave}
            />
          </div>)
        }

      </div>
    </div>
  )
}

export default RequestRevisionPopUp
